import { useConfig } from '@/contexts/ConfigContext';

export const useClientFrameNavigate = () => {
  const { IFRAME_URL } = useConfig();

  const navigateClient = (route: string) => {
    const iframe = document.getElementById('dasl-iframe') as HTMLIFrameElement;
    if (iframe?.contentWindow) {
      iframe.contentWindow.postMessage({ route }, IFRAME_URL);
    }
  };

  return { navigateClient };
};
